export default {
  Female: 'Nữ',
  Male: 'Nam',
  Other: 'Khác',
  F: 'Nữ',
  M: 'Nam',
  O: 'Khác',
  female: 'Nữ',
  male: 'Nam',
  other: 'Khác',
  f: 'Nữ',
  m: 'Nam',
  o: 'Khác',
  Gender: 'Giới tính',
  0: 'Nữ',
  1: 'Nam',
  2: 'Khác',
  'Patient Sex': 'Giới tính',
  PatientSex_F: 'Nữ',
  PatientSex_M: 'Nam',
  PatientSex_O: 'Khác',
  PatientSex_FEMALE: 'Nữ',
  PatientSex_MALE: 'Nam',
  PatientSex_Female: 'Nữ',
  PatientSex_Male: 'Nam',
  PatientSex_Nữ: 'Nữ',
  PatientSex_Nam: 'Nam',
  PatientSex_Khác: 'Khác',
  'Patient Age': 'Tuổi',
};
